// @ts-nocheck
import React, { Component } from 'react';

import TicketAdditionalInfo from './additionalInfo/ticketAdditionalInfo';
import TicketBarcode from '@/v2/wallet/items/barcode/barcode';

import styles from './ticket.module.scss';
import { getHeaderBackgroundColor, getTextFontColor } from '@/v2/helpers/ticketColors/ticketColorsHelper.ts';
import { EventModel } from '@/v2/models/eventModel.ts';
import { TicketCardv2 } from '@ticketmaster/global-design-system';
import { TicketModel } from '@/v2/models/ticketModel.ts';
import TicketHeader from '@/v2/wallet/items/ticket/header/header.tsx';
import TicketPortal from '@/v2/wallet/items/ticket/portal/portal.tsx';
import { RedemptionAvailabilityModel } from '@/v2/models/multiEventEnvelopeModel.ts';
import { EventLabelsModel } from '@/v2/models/eventTicketsModel.ts';

type Props = {
  activeToken: string;
  ticket: TicketModel;
  event: EventModel;
  redemptionAvailability: RedemptionAvailabilityModel;
  labels?: EventLabelsModel;
};

type State = any;

class Ticket extends Component<Props, State> {
  render() {
    const { ticket, event, activeToken, redemptionAvailability, labels } = this.props;
    const headerBackgroundColor = getHeaderBackgroundColor(ticket);
    const textFontColor = getTextFontColor(ticket);
    const status = ticket.voidedAt ? 'disabled' : 'primary';

    return (
      <TicketCardv2
        status={status}
        {...(!!headerBackgroundColor && !!textFontColor) && { wayfindingColors: { background: headerBackgroundColor, foreground: textFontColor } }}
      >
        <TicketHeader ticket={ticket}/>
        <div className={styles.ticketMiddleSection}>
          <TicketBarcode activeToken={activeToken} ticket={ticket} event={event} redemptionAvailability={redemptionAvailability}/>
        </div>
        {!ticket.voidedAt &&
            <div className={styles.ticketBottomSection}>
                <TicketPortal ticket={ticket} entryGateLabel={labels?.entryGate}/>
                <TicketAdditionalInfo ticket={ticket}/>
            </div>
        }
      </TicketCardv2>
    );
  }
}

export default Ticket;
